import React from 'react';

// material components
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

import PropTypes from "prop-types";

// constants
import {
    MARK_AS_PAID_DIALOG_TITLE,
    NO_PAYMENT_INFO_DIALOG_MESSAGE,
} from "./constants";

// styling
import './ConfirmMarkAsPaidDialog.css';

function ConfirmMarkAsPaidDialog(props) {

    // only worth spelling out when the user is marking a batch and just some of it is missing details
    const showDetail = props.selectedCount > 1

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="mark-as-paid-dialog-title"
            aria-describedby="mark-as-paid-dialog-description"
            PaperProps={{ className: "confirm-paid-dialog-paper" }}
        >
            <DialogTitle
                id="mark-as-paid-dialog-title"
                disableTypography
                className="confirm-paid-dialog-title"
            >
                <div className="confirm-paid-dialog-heading">
                    <span className="confirm-paid-dialog-icon">
                        <AttachMoneyIcon />
                    </span>
                    <span className="confirm-paid-dialog-heading-text">
                        {MARK_AS_PAID_DIALOG_TITLE}
                    </span>
                </div>
            </DialogTitle>
            <DialogContent className="confirm-paid-dialog-content">
                <p id="mark-as-paid-dialog-description" className="confirm-paid-dialog-message">
                    {NO_PAYMENT_INFO_DIALOG_MESSAGE}
                </p>
                {showDetail &&
                    <p className="confirm-paid-dialog-detail">
                        {props.missingCount} of the {props.selectedCount} selected invoices
                        {props.missingCount === 1 ? " has " : " have "}
                        no reference id, payment date or bank account attached.
                    </p>
                }
            </DialogContent>
            <DialogActions className="confirm-paid-dialog-actions" disableSpacing>
                <Button
                    onClick={props.handleClose}
                    variant="outlined"
                    className="confirm-paid-dialog-cancel"
                    autoFocus
                >
                    Go Back
                </Button>
                <Button
                    onClick={props.handleConfirm}
                    color="primary"
                    variant="contained"
                    className="confirm-paid-dialog-confirm"
                >
                    Mark as Paid
                </Button>
            </DialogActions>
        </Dialog>
    )

}

ConfirmMarkAsPaidDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    handleConfirm: PropTypes.func,
    missingCount: PropTypes.number,
    selectedCount: PropTypes.number
}

ConfirmMarkAsPaidDialog.defaultProps = {
    open: false,
    handleClose: () => {},
    handleConfirm: () => {},
    missingCount: 0,
    selectedCount: 0
}

export default ConfirmMarkAsPaidDialog
